import React from 'react'
import LandingPageWrapper from '../../../react4xp/components/LandingPageWrapper'
import { Region } from '@enonic/react-components';

function LandingPageLayout({title, intro, image, text, regions, isMini, bgColor, isWhite}) {
    return (
		<LandingPageWrapper
			hero={{
				bgColor: bgColor,
				whiteText: isWhite,
				invertImagePosition: false,
				title: title,
				image: image,
				content: intro
			}}
			sectionDividers={{
				top: (isMini || bgColor) ? false : true,
				bottom: false
			}}
			mainContent={text}
			region1={<Region name={regions.region1.name} regionData={regions.region1} />}
			region2={<Region name={regions.region2.name} regionData={regions.region2} />}
		/>
    )
}

export default (props) => <LandingPageLayout {...props} />
